import { ReactNode } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import Section from "@/app/features/shared/snap-section/Section";
import IntroAnchor from "@/app/features/shared/__to_be_integrated/ui/IntroAnchor";

export function ResearchDetailHeroFrame({ children }: { children: ReactNode }) {
    return <div className="relative w-full">{children}</div>;
}

export function ResearchDetailSectionsFrame({ children }: { children: ReactNode }) {
    return (
        <div className="relative w-full">
            <IntroAnchor />
            {children}
        </div>
    );
}

export function ResearchDetailSectionFrame({ children }: { children: ReactNode }) {
    return (
        <div>
            <Box sx={{ py: 4, px: { xs: '5%', md: '10%' } }}>
                <Divider />
            </Box>
            <Section>{children}</Section>
        </div>
    );
}

export function ResearchDetailPublicationsFrame({ children }: { children: ReactNode }) {
    return (
        <Section aria-labelledby="research-publications-heading">
            <Stack
                spacing={2}
                sx={{
                    display: 'flex',
                    flex: '1 1 auto',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    height: { md: '100%' },
                    minHeight: 0,
                    overflow: { md: 'hidden' },
                    paddingX: { xs: '5%', md: '10%' },
                    paddingY: 16,
                }}
            >
                <Typography id="research-publications-heading" component="h2" variant="h3">
                    Publikationsliste
                </Typography>
                {children}
            </Stack>
        </Section>
    );
}
